import { useEffect, useState } from 'react';
import { createLocalVideoTrack, type LocalVideoTrack } from 'livekit-client';

/**
 * Capture caméra locale jamais publiée sur la room : l'intervenant hors scène se voit à la place
 * qu'il occupera en direct, sans coût LiveKit ni egress. La piste est relâchée dès que la capture
 * n'est plus voulue, avant que la publication réelle ne reprenne le périphérique.
 */
export function useLocalCameraPreview(enabled: boolean, deviceId?: string): LocalVideoTrack | null {
  const [track, setTrack] = useState<LocalVideoTrack | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    let created: LocalVideoTrack | null = null;
    createLocalVideoTrack(deviceId ? { deviceId } : undefined)
      .then((localTrack) => {
        if (cancelled) {
          localTrack.stop();
          return;
        }
        created = localTrack;
        setTrack(localTrack);
      })
      .catch((error: unknown) => {
        console.warn('Aperçu caméra local indisponible', error);
      });
    return () => {
      cancelled = true;
      created?.stop();
      setTrack(null);
    };
  }, [enabled, deviceId]);

  return track;
}
